import React from 'react';

class FieldFile extends React.Component{

    constructor(props) {
        super(props);

        this._onChange = this._onChange.bind(this);
    }

    _onChange(event) {
        let input = event.target;
        let label = input.nextSibling;

        if (input.files[0]) {
            label.innerHTML = "<span>Файл прикреплен</span>";
            label.classList.add("is-set-file");
        } else {
            label.innerHTML = '<span>'+input.dataset.defaultTitle+'</span>';
            label.classList.remove("is-set-file");
        }
    }

    render() {
        const {item} = this.props;

        return (
            <div className="order-props__prop-item">
                <input type="hidden" name={item.property_id + '[ID]'} value=""/>
                <div className="form-control form-control--file">
                    <input type="file" defaultValue="" name={item.property_id + '[]'} id={item.property_id} data-default-title={item.name} onChange={this._onChange}/>
                    <label htmlFor={item.property_id} className="btn btn--file btn-block"><span>{item.name} </span></label>
                </div>
            </div>
        );
    }
}

export default FieldFile;